import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const useNavigationProtection = (cart, setCart) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Prevenir que el usuario abandone la página si hay productos en el carrito
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (cart.length > 0) {
        e.preventDefault();
        e.returnValue = 'Tienes productos en el carrito. ¿Estás seguro de que quieres salir?';
        return 'Tienes productos en el carrito. ¿Estás seguro de que quieres salir?';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [cart]);

  // Interceptar navegación interna interceptando clicks en enlaces y botones
  useEffect(() => {
    const handleClick = (e) => {
      if (cart.length > 0) {
        // Verificar si el click fue en un enlace o dentro de un enlace
        const link = e.target.closest('a[href]');
        if (link && link.href && !link.href.startsWith('javascript:')) {
          const href = link.getAttribute('href');
          // Solo interceptar links internos (que empiecen con /)
          if (href && href.startsWith('/')) {
            e.preventDefault();
            const confirmNavigation = window.confirm('Tienes productos en el carrito. ¿Estás seguro de que quieres abandonar esta página?');
            if (confirmNavigation) {
              setCart([]); // Limpiar carrito antes de navegar
              navigate(href);
            }
          }
        }

        // Verificar si el click fue en el botón de "atrás" (icono FaArrowLeft)
        const backButton = e.target.closest('button[aria-label="Volver"]');
        if (backButton) {
          e.preventDefault();
          e.stopPropagation();
          const confirmNavigation = window.confirm('Tienes productos en el carrito. ¿Estás seguro de que quieres abandonar esta página?');
          if (confirmNavigation) {
            setCart([]); // Limpiar carrito antes de navegar
            // Simular el comportamiento del botón original
            if (location.pathname.startsWith('/venta/')) {
              navigate('/');
            } else {
              navigate(-1);
            }
          }
        }
      }
    };

    document.addEventListener('click', handleClick, true);

    return () => {
      document.removeEventListener('click', handleClick, true);
    };
  }, [cart, navigate, location.pathname, setCart]);

  // Interceptar navegación del historial (botón atrás, navigate(-1), etc.)
  useEffect(() => {
    let hasAddedState = false;

    const handlePopState = (e) => {
      if (cart.length > 0) {
        const confirmNavigation = window.confirm('Tienes productos en el carrito. ¿Estás seguro de que quieres abandonar esta página?');
        if (confirmNavigation) {
          setCart([]); // Limpiar carrito antes de navegar
          // Permitir que la navegación continúe naturalmente
          return;
        } else {
          // Cancelar la navegación agregando un nuevo estado
          window.history.pushState(null, '', window.location.pathname + window.location.search);
        }
      }
    };

    // Solo agregar un estado al historial cuando hay productos en el carrito y no se ha agregado antes
    if (cart.length > 0 && !hasAddedState) {
      window.history.pushState(null, '', window.location.pathname + window.location.search);
      hasAddedState = true;
    }

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [cart.length > 0, setCart]); // Solo depender de si hay productos o no, no del array completo
};

export default useNavigationProtection;
